import { render, staticRenderFns } from "./FoodKindSelects.vue?vue&type=template&id=c6fe902e&"
import script from "./FoodKindSelects.vue?vue&type=script&lang=js&"
export * from "./FoodKindSelects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports